<template>
  <div>
    <div class="flex flex-col-reverse sm:flex-row  sm:items-start sm:justify-end ">
      <div class="2xl:basis-1/6 lg:basis-1/4 sm:basis-2/5 basis-full  grow ">
        <button type="button" class="flex flex-nowrap text-left  font-weight-600 px-3 py-2 text-xl font-bold leading-4 text-[#307946]   focus:outline-none focus:ring-2  focus:ring-offset-2">
          <img width="24px" class="pt-1 sm:hidden block" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
          <img width="36px" class="pt-1 sm:block hidden" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
          <p class="pl-2 leading-6 text-[#004C29] md:text-base text-sm sm:block hidden" v-html="selected.html"></p>
          <p class="pl-2 leading-6 text-[#004C29] md:text-base text-sm sm:hidden block" v-html="selected.htmlm"></p>
        </button>
        <p class="text-left sm:pl-14 pl-11 sm:pt-8  md:text-base text-sm  text-[#004C29] sm:block hidden "  v-html="selected.html2"></p>
        <p class="text-left sm:pl-14 pl-11 sm:pt-8  md:text-base text-sm  text-[#004C29] sm:hidden block "  v-html="selected.html2m"></p>
        <div class="flex flex-col sm:pt-40 items-start  ">
          <div v-for="x in unselected" :key="x.name">
            <button @click="toggle(x)" type="button" class="flex flex-inline  text-left  font-weight-600 pt-4 px-3 py-2 text-xl font-bold leading-4 text-[#307946]   focus:outline-none focus:ring-2  focus:ring-offset-2">
              <img width="24px" class="pt-1 sm:hidden block" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
              <img width="36px" class="pt-1 sm:block hidden" src="https://firebasestorage.googleapis.com/v0/b/brainandbrawn-ea849.appspot.com/o/cursor.png?alt=media&token=1bd83896-60ae-4d3b-aa91-ffda316e0454">
              <p class="pl-2 leading-6 text-[#004C29] md:text-base text-sm sm:block hidden" v-html="x.html"></p>
              <p class="pl-2 leading-6 text-[#004C29] md:text-base text-sm sm:hidden block" v-html="x.htmlm"></p>
            </button>
          </div>

        </div>
      </div>
      <div class="2xl:basis-5/6 lg:basis-3/4 sm:basis-3/5  basis-full grow ">
        <iframe class="sm:hidden block" :src="selected.gmap" width="100%" height="400" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
        <iframe class="sm:block hidden" :src="selected.gmap" width="100%" height="600" style="border:0;" allowfullscreen="" loading="lazy" referrerpolicy="no-referrer-when-downgrade"></iframe>
      </div>
    </div>
  </div>
</template>
<script>
export default {
  methods: {
    toggle (select) {
      const temp = this.selected
      this.unselected = this.unselected.filter(x => x.name !== select.name)
      this.unselected.push(temp)
      this.selected = select
    }
  },
  mounted () {
    this.selected = {
      name: 'socialEn',
      html: 'Social Enterprise <br> Sandbox',
      htmlm: 'Social Enterprise Sandbox',
      html2: 'Phichai,<br> Mueang Lampang,<br> Lampang, 52000',
      html2m: 'Phichai, Mueang Lampang, Lampang, 52000',
      gmap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d1893.3640668278924!2d99.57490029563141!3d18.359683295775653!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0!2zMTjCsDIxJzMwLjQiTiA5OcKwMzQnMzEuMyJF!5e0!3m2!1sen!2sth!4v1666236959778!5m2!1sen!2sth'
    }
  },
  data () {
    return {
      unselected: [
        {
          name: 'ca',
          html: 'Civilize Agriculture <br> (Social Enterprise)<br>Company Limited',
          htmlm: 'Civilize Agriculture (Social Enterprise) Company Limited',
          html2: '417/122 Nong Kwai,<br> Hang Dong,<br> Chiang Mai, 50230',
          html2m: '417/122 Nong Kwai, Hang Dong, Chiang Mai, 50230',
          gmap: 'https://www.google.com/maps/embed?pb=!1m14!1m8!1m3!1d3777.4419537606423!2d99.0339188!3d18.7784476!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0xe190d55dc067823e!2zMTjCsDQ2JzQxLjkiTiA5OcKwMDInMDIuMCJF!5e0!3m2!1sen!2sth!4v1666241722977!5m2!1sen!2st'
        },
        {
          name: 'payap',
          html: 'Demonstration Farm <br> at Payap University',
          htmlm: 'Demonstration Farm at Payap University',
          html2: 'San Phranet,<br> San Sai District,<br> Chiang Mai',
          html2m: 'San Phranet, San Sai District, Chiang Mai',
          gmap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3776.909329377602!2d99.04064161489696!3d18.802193687245587!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x5fd5220a6df26d20!2zMTjCsDQ4JzA3LjkiTiA5OcKwMDInMzQuMiJF!5e0!3m2!1sen!2sth!4v1666236772586!5m2!1sen!2sth'
        },
        {
          name: 'organic',
          html: 'Organic Tobacco <br> Research and <br> Development Station',
          htmlm: 'Organic Tobacco Research and Development Station',
          html2: 'Nong Han,<br> San Sai District,<br> Chiang Mai, 50290',
          html2m: 'Nong Han, San Sai District, Chiang Mai, 50290',
          gmap: 'https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3774.484252168079!2d98.99992031489863!3d18.909947987183408!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x47b00ce7164d803d!2zMTjCsDU0JzM1LjgiTiA5OcKwMDAnMDcuNiJF!5e0!3m2!1sen!2sth!4v1666236871129!5m2!1sen!2sth'
        }
      ],
      selected: {},
      place: [
        {
          name: 'socialEn',
          html: 'Social Enterprise <br> Sandbox',
          htmlm: 'Social Enterprise Sandbox',
          html2: 'Phichai,<br> Mueang Lampang,<br> Lampang, 52000',
          html2m: 'Phichai, Mueang Lampang, Lampang, 52000'
        },
        {
          name: 'ca',
          html: 'Civilize Agriculture <br> (Social Enterprise)<br>Company Limited',
          htmlm: 'Civilize Agriculture (Social Enterprise) Company Limited',
          html2: '417/122 Nong Kwai,<br> Hang Dong,<br> Chiang Mai, 50230',
          html2m: '417/122 Nong Kwai, Hang Dong, Chiang Mai, 50230'
        },
        {
          name: 'payap',
          html: 'Demonstration Farm <br> at Payap University',
          htmlm: 'Demonstration Farm at Payap University',
          html2: 'San Phranet,<br> San Sai District,<br> Chiang Mai',
          html2m: 'San Phranet, San Sai District, Chiang Mai'
        },
        {
          name: 'organic',
          html: 'Organic Tobacco <br> Research and <br> Development Station',
          htmlm: 'Organic Tobacco Research and Development Station',
          html2: 'Nong Han,<br> San Sai District,<br> Chiang Mai, 50290',
          html2m: 'Nong Han, San Sai District, Chiang Mai, 50290'
        }
      ]
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Gmap.vue